module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Ver otras ediciones":"Ver otras ediciones"},"en":{},"ca":{"Ver otras ediciones":"Veure altres edicions"}}')
  delete Component.options._Ctor
}
